import Default from "components/layouts/Guest/Default";
import SelectGroup from "components/templates/SelectGroup/SelectGroup";

const App = () => (
  <Default>
    <SelectGroup />
  </Default>
);

export default App;
